module.exports = __webpack_public_path__ + "static/media/C025.edb06f71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C025.jpg
// module id = 308
// module chunks = 0